import { render, staticRenderFns } from "./mobile-productService.vue?vue&type=template&id=344478d6&scoped=true&"
import script from "./mobile-productService.vue?vue&type=script&lang=js&"
export * from "./mobile-productService.vue?vue&type=script&lang=js&"
import style0 from "./mobile-productService.vue?vue&type=style&index=0&id=344478d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344478d6",
  null
  
)

export default component.exports